
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M141.9 316.1c-1.9-8.4-2.9-17.2-2.9-26.2v-37.2c0-5.8-4.7-10.6-10.5-10.6h-18c-5.8 0-10.5 4.7-10.5 10.6V290c0 19.9 3.9 39.1 11 57l30.9-30.9zM346 91.4C346 41 305.5 0 255.7 0s-90.3 41-90.3 91.4v201.2L346 112.2V91.4zm54.8 150.7h-18c-5.8 0-10.5 4.7-10.5 10.6V290c0 65.1-52.3 118.1-116.7 118.1-29.6 0-56.7-11.2-77.3-29.7L151 405.7c23.2 21.6 52.6 36.4 85.1 40.6v26.4H156c-5.8 0-10.5 4.7-10.5 10.6v18.2c0 5.8 4.7 10.6 10.5 10.6h199.4c5.8 0 10.5-4.7 10.5-10.6v-18.2c0-5.8-4.7-10.6-10.5-10.6h-80.3v-26.4c76.3-9.7 136.1-78.4 136.1-156.3v-37.2c0-5.9-4.7-10.7-10.4-10.7zM346 296.8V211L193.7 363.1c16.2 15.5 38 25.1 62 25.1 49.8 0 90.3-41 90.3-91.4zm90.3-225.5c-4.2-4.2-9.7-6.3-15.2-6.3s-11 2.1-15.2 6.3L75.7 401.4c-8.4 8.4-8.4 22 0 30.3 4.2 4.2 9.7 6.3 15.2 6.3s11-2.1 15.2-6.3l330.3-330.2c8.3-8.3 8.3-21.9-.1-30.2z"}})])
          )
        }
      }
    